import React, { useEffect } from 'react';

import style from './index.module.scss';
import { useMeetingTaskDate } from 'util/meeting';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'model';
import Schedule from 'page/TeamworkHome/component/Schedule';
import moment from 'moment';
import { getCalendarMeetings, getUsersMeetings } from 'model/meeting';
import CalendarBar from 'component/CalendarBar';
import { useActivate } from 'react-activation';
import { useScheduleContext } from 'page/MeetingSchedule/Provider/ScheduleProvider';

interface IProps {}

const ScheduleView: React.FC<IProps> = () => {
  const { originState, scheduleDispatch } = useScheduleContext();
  const { currentTime } = originState;
  const calendarMeetingRecords = useSelector((state: RootState) => state.meeting.calendarMeetingRecords);
  const recordsLoading = useSelector((state: RootState) => state.meeting.meetingRecordsLoading);
  const records = useSelector((state: RootState) => state.meeting.meetingRecords);
  const { noticeList, taskList } = useMeetingTaskDate(calendarMeetingRecords);
  const dispatch = useDispatch();

  const onSwitch = (beginTime: number, endTime: number) => {
    dispatch(
      getCalendarMeetings({
        beginTime,
        endTime,
        markConflict: true
      })
    );
  };

  const fetchMeetings = (selectDate?: number) => {
    const selectedDate = moment(selectDate || undefined);
    dispatch(
      getUsersMeetings({
        beginTime: selectedDate.startOf('d').valueOf(),
        endTime: selectedDate.endOf('d').valueOf(),
        markConflict: true
      })
    );
  };

  const refreshData = () => {
    const date = moment(currentTime || undefined);
    const day = date.day();
    dispatch(
      getCalendarMeetings({
        beginTime: date.subtract(day, 'd').startOf('d').valueOf(),
        endTime: date
          .add(6 - day, 'd')
          .endOf('d')
          .valueOf(),
        markConflict: true
      })
    );
    fetchMeetings(currentTime.valueOf());
  };

  const onSelectDate = (date: number) => {
    scheduleDispatch({
      type: 'SET_STATE',
      payload: {
        currentTime: date
      }
    });
  };

  useEffect(() => {
    fetchMeetings(currentTime.valueOf());
  }, [currentTime]);

  useActivate(() => {
    refreshData();
  });

  return (
    <div className={style.warp}>
      <CalendarBar onSelectDate={onSelectDate} onSwitch={onSwitch} noticeList={noticeList} taskList={taskList} />
      <div className={style.scheduleWarp}>
        <Schedule refresh={refreshData} records={records} loading={recordsLoading} from="schedule" />
      </div>
    </div>
  );
};

export default ScheduleView;
